<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/JOlPXP/image/1.png?1701092724756" alt="This image is the cover for the book Andi’s Mermaid Tale"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Andi’s Mermaid Tale
      </h1>
      <p class="bookDescription body article font2">
        <p>Have you ever had a wish come true? When Andi and her sisters go on a trip to the beach, something magical happens. Andi sets out on an enchanting underwater adventure to scour the ocean in search of the prettiest shell in the sea. Along the way, she meets some new sea friends who help her on her quest. Andi spends all day searching and when all hope of finding her shell seems lost, an unexpected gift from an old friend might be just what she’s looking for. Will Andi be able to succeed and show her sisters the prettiest shell in the sea, or will she return to the beach empty-handed?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kristie Harris
      </h2>
      
      <p class="authorDescription body article">Kristie Harris is a proud Wiradjuri woman from Australia. She lives in Brisbane with her three gorgeous girls, husband, and fur babies. Kristie holds an Associate Degree in Creative Writing and is currently studying her Bachelor of Arts – Majoring in Creative Writing. When Kristie isn’t reading, writing, or studying, she enjoys playing field hockey, painting, and chasing her kids around. Andi’s Mermaid Tale was written for her girls and is her debut book.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?43b2767f